// 这里是前端统一SDK
import { getTenantLangSetting } from '@/services'
import Tracker, {
  IBaseMiddlewareNext,
  IEventContext,
  TrackViewContext,
  BaseSender,
  IBaseSenderOPtions,
  createDefaultMiddlewares,
  TrackView,
} from '@dragonpass/intl-unified-tracker'
import { SensorsSender } from '@dragonpass/intl-unified-tracker-sender'
import initSensor from './sensor'
import { throttle } from 'lodash'

type dataType =
  | 'string'
  | 'number'
  | 'bigint'
  | 'boolean'
  | 'symbol'
  | 'undefined'
  | 'object'
  | 'function'

const getStorage = (key: string) => {
  const storage = window.localStorage
  const storageData = storage.getItem(key)
  if (!storageData) return storageData
  try {
    const resData = JSON.parse(storageData)
    const dataType: dataType = resData.type
    const { data } = resData

    // 布尔值 返回data
    if (dataType === 'boolean') return data === true
    // 对象返回
    if (dataType === 'string' && data === 'null') {
      return null
    }
    // z字符串返回
    if (dataType === 'string' && data === 'undefined') return undefined
    // number
    if (dataType === 'number') return Number(data)
    return data
  } catch (error) {
    return storageData
  }
}

const getUrlParam = (name: string, searchStr?: string): string | null => {
  const { search, hash } = window.location

  const hashSearch = hash.split('?')[1]

  searchStr = searchStr || search.substr(1) || hash.split('?')[1] || ''
  if (hashSearch) searchStr += `${searchStr ? '&' : ''}${hashSearch}`
  if (searchStr.indexOf('?') !== -1) searchStr = searchStr.split('?')[1]
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r = searchStr.match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}

let _tracker: Tracker | null = null

function trackUserLogin() {
  const memberCode = getUrlParam('memberCode') || getStorage('memberCode') || ''
  const guestCode = getUrlParam('guestCode') || getStorage('guestCode') || ''
  const openId = getUrlParam('openId') || ''
  const h5Token = getStorage('h5Token')
  if (memberCode) {
    window.dpTracker?.identify({
      user_id: memberCode,
      identity_mp_openid: openId,
    })
  }
  setTimeout(() => {
    window.dpTracker?.setPublicParams({
      guest_code: guestCode,
    })
  }, 1000)
}

// 登出
export function trackUserLogout() {
  window.dpTracker?.anonymous()
}

export function setCommonParams() {
  const channel = getUrlParam('channel') || ''
  const tenantCode = getUrlParam('tenantCode') || getStorage('tenantCode') || ''
  window.dpTracker?.setPublicParams({
    source: channel,
    project_id: tenantCode,
  })
}

// 增加节流策略：5秒内只执行一次
const throttleInitDpTracker = throttle(async function initDpTracker() {
  // 开启后不重复 getTenantLangSetting
  if (window.dpTracker) {
    console.log('Dont need InitDpTracker')
    return
  }
  const codeFromStorage = getStorage('tenantCode')
  const codeFromUrl = getUrlParam('tenantCode')
  const tenantCode = codeFromUrl || codeFromStorage || ''
  if (tenantCode) {
    const res = await getTenantLangSetting({ tenantCode })
    const { enableEventTracking } = res
    // 开启埋点跟踪
    if (enableEventTracking) {
      useTracker()
    }
  }
}, 5000)

function useTracker() {
  if (window.dpTracker) {
    console.log('Dont need InitDpTracker')
    return
  }
  // 初始化神策
  initSensor()
  console.log('initDpTracker')
  const channel = getUrlParam('channel') || ''
  const tenantCode = getUrlParam('tenantCode') || getStorage('tenantCode') || ''

  window.dpTracker = _tracker = new Tracker({
    enableDebug: false,
    isInitIdentify: false,
    publicParams: {
      source: channel,
      project_id: tenantCode,
    },
    senders: [new SensorsSender()],
    middlewares: createDefaultMiddlewares(),
    identifySources: {
      device_id: 'publicParams',
    },
  })
  setCommonParams()
  trackUserLogin()
}

export default throttleInitDpTracker
